/**
 * @typedef TypeSizes
 * @property {string} value Идентификатор размера
 * @property {string} className Имя класса
 */

/**
 * Список типов размеров
 * @readonly
 * @enum {TypeSizes}
 * @const
 */
var TYPE_SIZES = Object.freeze({
  normal: {
    value: 'normal',
    className: ''
  },
  small: {
    value: 'small',
    className: '_small'
  },
  extraSmall: {
    value: 'extra-small',
    className: '_extra-small'
  },
  large: {
    value: 'large',
    className: '_large'
  }
});
/**
 * @typedef TypePlatform
 * @property {string} value Идентификатор платформы
 * @property {string} className Имя класса
 */

/**
 * Список типов платформ
 * @readonly
 * @enum {TypePlatform}
 * @const
 */

var TYPE_PLATFORM = Object.freeze({
  desktop: {
    value: 'desktop',
    className: '_d'
  },
  mobile: {
    value: 'mobile',
    className: ''
  }
});
/**
 * Список типов кнопки
 * @readonly
 * @enum {TypeSizes}
 * @const
 */

var TYPES_BUTTON = Object.freeze({
  default: {
    value: 'default',
    className: ''
  },
  secondary: {
    value: 'secondary',
    className: '_secondary'
  },
  more: {
    value: 'more',
    className: '_more'
  },
  link: {
    value: 'link',
    className: '_link'
  },
  linkDashed: {
    value: 'link-dashed',
    className: '_link-dashed'
  }
});

export { TYPES_BUTTON, TYPE_PLATFORM, TYPE_SIZES };
